import whatsappIcon from 'assets/icons/whatsapp.svg'
import telegramIcon from 'assets/icons/telegram.svg'
import imessageIcon from 'assets/icons/imessage.svg'
import signalIcon from 'assets/icons/signal.svg'
import {
    Box,
    Card,
    Typography,
    Modal,
    ModalDialog,
    Button,
    Alert,
    Snackbar,
} from '@mui/joy'
import { useEffect, useState } from 'react'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import WhatsAppIntegration from 'components/ChatApisPreview/WhatsAppIntegration'
import SignalIntegration from 'components/ChatApisPreview/SignalAppIntegration'

type Props = {}

export type ChatApiItem = {
    key: string
    icon: any
    label: string
    isDisabled?: boolean
}

export const chatApiList: ChatApiItem[] = [
    {
        key: 'whatsapp.com',
        icon: whatsappIcon,
        label: 'WhatsApp',
    },
    {
        key: 'signal.org',
        icon: signalIcon,
        label: 'Signal',
        isDisabled: false,
    },
    {
        key: 'telegram',
        icon: telegramIcon,
        label: 'Telegram',
        isDisabled: true,
    },
    {
        key: 'imessage',
        icon: imessageIcon,
        label: 'iMessage',
        isDisabled: true,
    },
]

const ChatApisPreview = (props: Props) => {
    const [open, setOpen] = useState(false)
    const [item, setItem] = useState<ChatApiItem | null>(null)
    const [responseError, setResponseError] = useState<string | null>(null)

    useEffect(() => {
        item ? setOpen(true) : setOpen(false)
    }, [item])

    return (
        <>
            <Box
                sx={{
                    maxWidth: '600px',
                    display: 'flex',
                    gap: 2,
                    alignItems: 'center',
                    justifyContent: 'space-evenly',
                }}
            >
                {chatApiList.map((item, i) => (
                    <Card
                        variant="outlined"
                        sx={{
                            width: '130px',
                            height: '130px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'border-color 0.3s ease',
                            cursor: item.isDisabled ? 'not-allowed' : 'pointer',
                            opacity: item.isDisabled ? 0.7 : 1,
                            '&:hover': {
                                borderColor: item.isDisabled
                                    ? ''
                                    : 'primary.solidBg',
                            },
                        }}
                        onClick={() => {
                            if (item.isDisabled) return
                            setItem(item)
                        }}
                        key={i}
                    >
                        <img src={item.icon} alt={item.label} />
                        <Typography>{item.label}</Typography>
                    </Card>
                ))}
            </Box>

            {item ? (
                <Modal
                    open={open}
                    onClose={(_, reason) => {
                        if (reason === 'backdropClick') return
                        if (reason === 'escapeKeyDown') return
                        setItem(null)
                    }}
                    sx={{
                        marginLeft: '240px',
                    }}
                >
                    <ModalDialog
                        sx={{
                            borderRadius: 'md',
                            p: 3,
                            minWidth: 500,
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignContent: 'flex-start',
                            }}
                        >
                            <Typography
                                sx={{
                                    py: 1,
                                }}
                                level="title-lg"
                            >
                                Add New Channel
                            </Typography>
                            <CloseRoundedIcon
                                sx={{
                                    cursor: 'pointer',
                                    my: 1,
                                }}
                                onClick={() => setItem(null)}
                            />
                        </Box>

                        {item.key === 'whatsapp.com' ? (
                            <WhatsAppIntegration
                                item={item}
                                setPopup={setItem}
                                setResponseError={setResponseError}
                            />
                        ) : item.key === 'signal.org' ? (
                            <SignalIntegration item={item} setPopup={setItem} />
                        ) : (
                            <>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: 1,
                                        alignItems: 'center',
                                    }}
                                >
                                    <img src={item.icon} alt={item.label} />
                                    <Typography level="title-md">
                                        {item?.label}
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                >
                                    <Typography level="body-md" sx={{ mt: 1 }}>
                                        1. Open {item.label} on your phone
                                    </Typography>
                                    <Typography level="body-md" sx={{ mt: 1 }}>
                                        2. Tap Menu or Settings and select
                                        Linked Devices
                                    </Typography>
                                    <Typography level="body-md" sx={{ mt: 1 }}>
                                        3. Point your phone to this screen to
                                        capture the code
                                    </Typography>
                                </Box>
                            </>
                        )}
                    </ModalDialog>
                </Modal>
            ) : null}

            <Snackbar
                open={!!responseError}
                onClose={() => setResponseError(null)}
                autoHideDuration={4000}
                variant="soft"
                color="danger"
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert color="danger">{responseError}</Alert>
            </Snackbar>
        </>
    )
}

export default ChatApisPreview
